import type {
  AdminCreateUserRequest,
  AdminCreateUserResponse,
  CreateUserRequest,
  UpdateUserRequest,
  UserProfile,
} from '../types/user';

const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:4000';

async function requestUser(
  accessToken: string,
  method: 'POST' | 'PUT',
  body: CreateUserRequest | UpdateUserRequest,
): Promise<UserProfile> {
  const response = await fetch(`${API_URL}/api/users/me`, {
    method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const result = await response.json().catch(() => ({})) as { error?: string };
    throw new Error(result.error ?? 'Unable to save your account');
  }

  return response.json() as Promise<UserProfile>;
}

export function upsertUser(accessToken: string, request: CreateUserRequest): Promise<UserProfile> {
  return requestUser(accessToken, 'POST', request);
}

export function updateUser(accessToken: string, request: UpdateUserRequest): Promise<UserProfile> {
  return requestUser(accessToken, 'PUT', request);
}

export async function createUser(
  accessToken: string,
  request: AdminCreateUserRequest,
): Promise<AdminCreateUserResponse> {
  const response = await fetch(`${API_URL}/api/users/admin`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  if (!response.ok) {
    const result = await response.json().catch(() => ({})) as { error?: string };
    throw new Error(result.error ?? 'Unable to create user');
  }
  return response.json() as Promise<AdminCreateUserResponse>;
}
